import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ profileId = '', ...params }) => {
  return await dponetAPI.get(`/backoffice/profiles/${profileId}`, { params })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/backoffice/profiles', data)
}

const edit = async ({ profileId = '', ...data }) => {
  return await dponetAPI.put(`/backoffice/profiles/${profileId}`, data)
}

const changeStatus = async ({ profileId }) => {
  return await dponetAPI.put(`/backoffice/profiles/${profileId}/change_status`)
}

const userProfiles = {
  get,
  create,
  edit,
  changeStatus,
}

export default userProfiles
